import {FAILURE, PENDING, SUCCESS} from '../../constants'
import {useReducer} from 'react'

const ActionTypes = {FAILURE, PENDING, SUCCESS}
const InitialState = {
  data: [],
  errors: null,
  isLoading: false,
}

const Reducer = (state = InitialState, action) => {
  switch (action.type) {
    case PENDING:
      return {
        ...state,
        isLoading: true,
        error: null,
      }
    case SUCCESS:
      return {
        ...state,
        data: action.payload || [],
        isLoading: false,
        errors: null,
      }
    case FAILURE:
      return {
        ...state,
        errors: action.payload.errors,
        isLoading: false,
        data: [],
      }
    default:
      return state
  }
}

const useGetAdvanceOptionRangeReducer = (state = InitialState) => {
  return useReducer(Reducer, state)
}

export default useGetAdvanceOptionRangeReducer
export {ActionTypes, InitialState, Reducer}
